import baseAPI from '@/api/base';
import {
  EditKnowledgeBaseArticle,
  GetKnowledgeBaseArticle,
  RegisterKnowledgeBaseArticle,
} from '@/dtos/knowledge_base_article.dto';
import {
  DELETE_KNOWLEDGE_BASE_ARTICLE_URL,
  EDIT_KNOWLEDGE_BASE_ARTICLE_URL,
  GET_KNOWLEDGE_BASE_ARTICLE_URL,
  REGISTER_KNOWLEDGE_BASE_ARTICLE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class KnowledgeBaseArticle {
  static getKnowledgeBaseArticles = async (
    params: GetKnowledgeBaseArticle
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_KNOWLEDGE_BASE_ARTICLE_URL, {
      params,
    });
    return response;
  };

  static registerKnowledgeBaseArticle = async (
    payload: RegisterKnowledgeBaseArticle
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_KNOWLEDGE_BASE_ARTICLE_URL, {
      ...payload,
    });
    return response;
  };

  static editKnowledgeBaseArticle = async (
    payload: EditKnowledgeBaseArticle
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_KNOWLEDGE_BASE_ARTICLE_URL, {
      ...payload,
    });
    return response;
  };

  static deleteKnowledgeBaseArticle = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_KNOWLEDGE_BASE_ARTICLE_URL}/${id}`
    );
    return response;
  };
}

export default KnowledgeBaseArticle;
